const validChildren = {
  VisualElementPicker: 'VisualElementPicker',
  Input: 'InputCard.Input',
  Actions: 'InputCard.Actions',
  Pair: 'InputCard.Pair',
  Constraint: 'InputCard.Constraint',
  Utility: 'InputCard.Utility'
};
const requiredChildren = {
  VisualElementPicker: 'VisualElementPicker',
  Input: 'InputCard.Input',
  Actions: 'InputCard.Actions'
};
const validComponentNames = Object.keys(validChildren);

export { requiredChildren, validChildren, validComponentNames };
